import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JL } from 'jsnlog';
import { CondicionesDialogComponent } from './components/condiciones-dialog/condiciones-dialog.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { MatDialogModule, MatCheckboxModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, MatTooltipModule, MatCardModule, MatFormFieldModule, MatTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CargandoComponent } from './components/cargando/cargando.component';
import { PasswordFieldComponent } from './components/password-field/password-field.component';
import { MatInputModule } from '@angular/material/input';
import { DropdownGeneralComponent } from './components/dropdown-general/dropdown-general.component';
import { DropExplotacionDirective, DropEspecieDirective, DropEspeciePRDirective, DropMesDirective } from './directives/drop-directives.directive';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NoEncontradoComponent } from './components/no-encontrado/no-encontrado.component';

@NgModule({
  entryComponents: [AlertDialogComponent, CondicionesDialogComponent],
  declarations: [AlertDialogComponent, CondicionesDialogComponent, CargandoComponent, PasswordFieldComponent, DropdownGeneralComponent, DropExplotacionDirective, DropEspecieDirective, DropEspeciePRDirective, DropMesDirective, NoEncontradoComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    DropDownsModule,
    MatTabsModule
  ],
  exports: [
    CargandoComponent,
    PasswordFieldComponent,
    DropdownGeneralComponent,
    DropExplotacionDirective,
    DropEspecieDirective,
    DropEspeciePRDirective,
    DropMesDirective,
    MatTooltipModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatDialogModule,
    MatTabsModule
  ],
  providers: [
    //{ provide: 'JSNLOG', useValue: JL }
  ],
})
export class SharedModule { }
